export const apiBaseUrlSelector = state =>
  state.getIn(['app', 'global', 'configuration', 'urls', 'api']);

export const identityBaseUrlSelector = state =>
  state.getIn(['app', 'global', 'configuration', 'urls', 'identity']);

export const capacityApiBaseUrlSelector = state =>
  state.getIn(['app', 'global', 'configuration', 'urls', 'capacityApi']);

export const appKeysSelector = state =>
  state.getIn(['app', 'global', 'configuration', 'keys']);

export const capacityTokenSelector = state =>
  state.getIn(['app', 'global', 'configuration', 'keys', 'capacity']);

export const gmapsKeySelector = state =>
  state.getIn(['app', 'global', 'configuration', 'keys', 'gmaps_api_key']);

export const golemApiSelector = state =>
  state.getIn(['app', 'global', 'configuration', 'urls', 'golemApi']);

export const userDataSelector = state =>
  state.getIn(['app', 'global', 'userData']);

export const dotNumberSelector = state =>
  state.getIn(['app', 'global', 'userDataIm', 'claims', 'carrier_dot_number']);

export const verifiedCarrierIdSelector = state =>
  state.getIn(['app', 'global', 'userDataIm', 'claims', 'verified_carrier_id']);

export const isPaidActiveSelector = state =>
  state.getIn(['app', 'global', 'userDataIm', 'claims', 'is_paid_active']);

export const currentUserIdSelector = state =>
  state.getIn(['app', 'global', 'userDataIm', 'claims', 'user_id']);

export const carrierNameSelector = state =>
  state.getIn(['app', 'global', 'userDataIm', 'claims', 'carrier_name']);

export const lwTokenSelector = state =>
  state.getIn(['app', 'global', 'userDataIm', 'claims', 'api_token']);

export const subscriptionExpiredSelector = state =>
  state.getIn(['app', 'global', 'subscriptionExpired']);
